import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils.js';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold uppercase tracking-wider transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-[var(--primary,var(--color-accent))] text-[var(--on-primary,var(--color-on-accent))]',
        secondary: 'border-[var(--border,var(--color-border))] bg-[var(--secondary-container,var(--color-background-muted))] text-[var(--foreground,var(--color-text-primary))]',
        outline: 'border-[var(--border,var(--color-border))] bg-white text-[var(--foreground,var(--color-text-primary))]',
        success: 'border-transparent bg-emerald-500/10 text-emerald-700 dark:text-emerald-400',
        warning: 'border-transparent bg-amber-500/10 text-amber-800 dark:text-amber-300',
        destructive: 'border-transparent bg-red-500/10 text-red-700 dark:text-red-400',
        accent: 'border-transparent bg-[var(--accent,var(--color-accent))]/15 text-[var(--accent,var(--color-accent))] font-extrabold',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(badgeVariants({ variant, className }))}
      data-astryx-badge=""
      {...props}
    />
  );
});
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
